import axios from 'axios'

import { SETTINGS, prepareHeaders } from './config.js'

async function prepareConfig(params = undefined) {
  var config = {}

  config['headers'] = await prepareHeaders()
  if (params) {
    config['params'] = params
  }

  return config
}

async function makeGetRequest(apiView, params) {
  return axios.get(`${SETTINGS.apiUrl}/${apiView}`, await prepareConfig(params))
}

async function makePostRequest(apiView, data, addHeaderCallback = undefined) {
  var config = await prepareConfig()
  if (addHeaderCallback) {
    config['headers'] = addHeaderCallback(config['headers'])
  }
  return axios.post(`${SETTINGS.apiUrl}/${apiView}`, data, config)
}

async function makePutRequest(apiView, data) {
  return axios.put(`${SETTINGS.apiUrl}/${apiView}`, data, await prepareConfig())
}

async function makeDeleteRequest(apiView) {
  return axios.delete(`${SETTINGS.apiUrl}/${apiView}`, await prepareConfig())
}

export {
  makeGetRequest,
  makePostRequest,
  makePutRequest,
  makeDeleteRequest,
}
